
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/docs/resources",
      function () {
        return require("private-next-pages/docs/resources/index.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/docs/resources"])
      });
    }
  